import { render, staticRenderFns } from "./TaxPayerDetailForm.vue?vue&type=template&id=794e3930&"
import script from "./TaxPayerDetailForm.vue?vue&type=script&lang=js&"
export * from "./TaxPayerDetailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports